<template>
    <!--完成画面-->
    <div class="preview-list">
        <div class="c-result__title">完成！</div>
        <canvas id="seal_canvas" width="1253" height="1820" class="" style="display: none"></canvas>
        <div class="preview-item c-result__image" v-if="this.generatedP1 && !this.isStandAlone"><img :src="generatedP1" alt="" /></div>
        <div class="w-100 py-5">
            <button type="button" class="button--download" @click="downloadPDF" v-if="downloadPDFEnable"><v-icon left dark> mdi-download </v-icon>ダウンロードする</button>
        </div>
    </div>
</template>

<script>
import { jsPDF } from "jspdf";

var WebFont = require("webfontloader");
WebFont.load({
    google: {
        families: ["Noto Sans JP"],
    },
    active: function () {
        // console.log("Google font is active.");
    },
});

export default {
    name: "SealDino",
    props: {
        avatarCanvas: undefined,
        firstname: {
            type: String,
            required: false,
        },
        loadingContents: {
            type: Boolean,
            default: false,
        },
        BoySelected: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            required: true,
        },
        selectedPart: {
            type: Object,
            default: null,
            required: true,
        },
    },
    data() {
        return {
            generated: false,
            generatedP1: "",
            generatedP2: "",
            generatedP3: "",
            generatedP4: "",
            generatedP5: "",
            AvatarPosition: 1, //探すアバターの位置downloadPDFEnable: true,
            downloadPDFEnable: true,
            isStandAlone: false,
            avator_canvas: null,
        };
    },
    head: {
        link: [
            { rel: "preconnect", href: "https://fonts.googleapis.com" },
            { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap" },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/earlyaccess/roundedmplus1c.css" },
        ],
        script: [{ type: "text/javascript", src: "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" }],
    },
    async created() {
        // console.log("mode >> ", this.mode);
        switch (this.mode) {
            case "line":
                this.downloadPDFEnable = false;
                break;
            case "sa-rpa":
                this.isStandAlone = true;
                break;
            default:
                break;
        }
    },
    mounted() {
        console.log("Props: avatarCanvas", this.avatarCanvas);
        console.log("selectedPart >> ", this.selectedPart);
        this.setDefault();
    },
    methods: {
        setDefault: function () {
            this.generateImage();
        },
        generateImage: async function () {
            this.generated = true;
            this.avator_canvas = await this.avatarCanvas;
            await this.generateContent();
            setTimeout(this.previewContent, 3000);
            setTimeout(this.loadingClose, 5000);
        },
        Debug() {},
        async previewContent() {
            console.log("call : previewContent");
            //P1
            const $p1_canvas_new = await document.getElementById("seal_canvas");
            const p1_context_new = await $p1_canvas_new.getContext("2d");
            const base64_p1 = await p1_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP1 = await base64_p1;
            console.log("done : previewContent");

            // this.downloadImage();
        },
        loadingClose: function () {
            // タイマーで動作させたい処理
            this.loading = false;
            this.$emit("loadingState", this.loading);
            console.log("done : loadingClose");
        },
        downloadImage: function () {
            // 生成した画像をダウンロードする
            console.log("call downloadImage");
            // const $canvas = document.getElementById("canvas");
            const $canvas = this.avatarCanvas;
            const $a = document.createElement("a");
            $a.href = $canvas.toDataURL("image/png");
            $a.download = "contents.png";
            $a.click();
        },
        generateContent: async function () {
            console.log("call : generateContent");
            //名前を生成
            var name = await this.firstname;
            // var name = "いちじょう こうたろう";
            name = name.toUpperCase();

            // const avator = await this.avator_canvas;
            //アバターキャンバスの読み込み
            const $avator = await this.avator_canvas;

            //キャンバスの初期化
            const $seal_canvas = document.getElementById("seal_canvas");
            const context = $seal_canvas.getContext("2d");
            context.clearRect(0, 0, $seal_canvas.width, $seal_canvas.height);

            var x_pos = 0;
            var y_pos = 0;
            var x_size = 0;
            var y_size = 0;
            var font_size = 0;

            //画像の作成
            const image = new Image();
            const layer = new Image();
            const backhair = new Image();

            //背景画像、フロントレイヤーの読み込み
            image.src = await require(`@/assets/img/contents/dino/background-dino.png`);
            layer.src = require(`@/assets/img/contents/dino/front-dino.png`);
            backhair.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
            let LoadImages = [image, layer, backhair];

            //読み込み完了でマッピング処理
            this.setLoadAllCallback(LoadImages, function () {
                //背景読み込み
                context.drawImage(image, 0, 0, $seal_canvas.width, $seal_canvas.height);

                //初期化
                var textAreaWidth = 0;
                var textWidth = 0;
                var textList = "";
                var lineHeight = 0;

                //シール１（アバター）
                x_pos = 139;
                y_pos = 106;
                x_size = 498;
                y_size = 349;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール２（アバター）
                x_pos = 561;
                y_pos = 175;
                x_size = 498;
                y_size = 349;
                context.rotate((-4.7 * Math.PI) / 180);
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);
                context.rotate((4.7 * Math.PI) / 180);

                //シール3（アバター）
                x_pos = 373;
                y_pos = 510;
                x_size = 362;
                y_size = 254;
                context.rotate((7.5 * Math.PI) / 180);
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);
                context.rotate((-7.5 * Math.PI) / 180);

                //シール4（アバター）
                x_pos = 686.5;
                y_pos = 806;
                x_size = 224;
                y_size = 157;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール5（アバター）
                //テキストのみ

                //シール6（アバター）
                x_pos = 728;
                y_pos = 1041;
                x_size = 118;
                y_size = 83;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール7-1（アバター）
                x_pos = 60;
                y_pos = 1138;
                x_size = 202;
                y_size = 141;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール7-2（アバター）
                x_pos = 60;
                y_pos = 1290;
                x_size = 202;
                y_size = 141;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール7-3（アバター）
                x_pos = 60;
                y_pos = 1442;
                x_size = 202;
                y_size = 141;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール7-4（アバター）
                x_pos = 60;
                y_pos = 1593;
                x_size = 202;
                y_size = 141;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール8-1（アバター）
                x_pos = 607;
                y_pos = 1154;
                x_size = 113;
                y_size = 79;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール8-2（アバター）
                x_pos = 720;
                y_pos = 1154;
                x_size = 113;
                y_size = 79;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール8-3（アバター）
                x_pos = 834;
                y_pos = 1154;
                x_size = 113;
                y_size = 79;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール8-4（アバター）
                x_pos = 947;
                y_pos = 1154;
                x_size = 113;
                y_size = 79;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール8-5（アバター）
                x_pos = 1061;
                y_pos = 1154;
                x_size = 113;
                y_size = 79;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール9-1（アバター）
                x_pos = 603;
                y_pos = 1595;
                x_size = 78;
                y_size = 55;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール9-2（アバター）
                x_pos = 891;
                y_pos = 1595;
                x_size = 78;
                y_size = 55;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール9-3（アバター）
                x_pos = 603;
                y_pos = 1675;
                x_size = 78;
                y_size = 55;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //シール9-4（アバター）
                x_pos = 891;
                y_pos = 1675;
                x_size = 78;
                y_size = 55;
                context.drawImage(backhair, x_pos, y_pos, x_size, y_size);
                context.drawImage($avator, x_pos, y_pos, x_size, y_size);

                //フロントレイヤー
                context.drawImage(layer, 0, 0, $seal_canvas.width, $seal_canvas.height);

                //シール１（名前）
                x_pos = 208;
                y_pos = 455;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(135, 110, 96)";

                textAreaWidth = 320;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール２（名前）
                x_pos = 710;
                y_pos = 460;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 365;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール３（名前）
                x_pos = 238;
                y_pos = 916;
                font_size = 20;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール4（名前）
                x_pos = 760;
                y_pos = 745;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(28, 79, 161)";

                textAreaWidth = 336;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール5（名前）
                x_pos = 750;
                y_pos = 988;
                font_size = 20;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(135, 110, 96)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール６（名前）
                x_pos = 825;
                y_pos = 1095;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(28, 79, 161)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール７−１（名前）
                x_pos = 232;
                y_pos = 1220;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール７−２（名前）
                x_pos = 232;
                y_pos = 1370;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール７−３（名前）
                x_pos = 232;
                y_pos = 1525;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール７−４（名前）
                x_pos = 232;
                y_pos = 1676;
                font_size = 24;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 300;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール８ー１（名前）
                x_pos = 650;
                y_pos = 1260;
                font_size = 18;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textList = name.split("\n");
                lineHeight = context.measureText("あ").width;
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });

                //シール８ー２（名前）
                x_pos = 765;
                y_pos = 1260;
                font_size = 18;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textList = name.split("\n");
                lineHeight = context.measureText("あ").width;
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });

                //シール８ー３（名前）
                x_pos = 880;
                y_pos = 1260;
                font_size = 18;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textList = name.split("\n");
                lineHeight = context.measureText("あ").width;
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });

                //シール８ー４（名前）
                x_pos = 995;
                y_pos = 1260;
                font_size = 18;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textList = name.split("\n");
                lineHeight = context.measureText("あ").width;
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });

                //シール８ー５（名前）
                x_pos = 1110;
                y_pos = 1260;
                font_size = 18;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textList = name.split("\n");
                lineHeight = context.measureText("あ").width;
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });
                textList.forEach(function (elm, i) {
                    Array.prototype.forEach.call(elm, function (ch, j) {
                        context.fillText(ch, x_pos - lineHeight * i, y_pos + lineHeight * j);
                    });
                });

                //シール９ー１（名前）
                x_pos = 676;
                y_pos = 1630;
                font_size = 14;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 185;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール９ー２（名前）
                x_pos = 965;
                y_pos = 1630;
                font_size = 14;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 185;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール９ー３（名前）
                x_pos = 676;
                y_pos = 1710;
                font_size = 14;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 185;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

                //シール９ー４（名前）
                x_pos = 965;
                y_pos = 1710;
                font_size = 14;
                context.font = "700 " + String(font_size) + "pt 'Noto Sans JP'";
                context.fillStyle = "rgba(255, 255, 255)";

                textAreaWidth = 185;
                textWidth = context.measureText(name).width;
                if (textAreaWidth < textWidth) {
                    //
                } else {
                    x_pos = x_pos + (textAreaWidth - textWidth) / 2;
                }
                context.fillText(name, x_pos, y_pos, textAreaWidth);

            });
            console.log("done : generateContent");
        },
        setLoadAllCallback: function (elems, callback) {
            var count = 0;
            for (var i = 0; i < elems.length; ++i) {
                elems[i].onload = function () {
                    ++count;
                    if (count == elems.length) {
                        // All elements have been loaded.
                        callback(elems);
                    }
                };
            }
        },
        downloadPDF: function () {
            const pdf = new jsPDF("p", "pt", [419.528, 283.465]);
            var width = pdf.internal.pageSize.width * 0.98;
            var offset_x = (pdf.internal.pageSize.width * 0.98 - pdf.internal.pageSize.width) / 2;

            var height = pdf.internal.pageSize.height * 0.98;
            var offset_y = (pdf.internal.pageSize.height * 0.98 - pdf.internal.pageSize.height) / 2 + 2;

            const page_onamae = document.getElementById("seal_canvas");
            var page_onamae_url = page_onamae.toDataURL();
            const canvas_onamae = new Image();
            canvas_onamae.src = page_onamae_url;
            pdf.addImage(canvas_onamae, "PNG", -offset_x, -offset_y, width, height);

            var name = this.firstname;
            var fname = "Avator_Seal_" + name + ".pdf";
            pdf.save(fname);
        },
    },
};
</script>

<style>
@import "@/assets/css/app.css";
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap");
</style>
